import { Tooltip, Typography } from '@material-ui/core'

import { getTranslate } from '../../../localization'
import { SystemReserve } from '../../../types/inventoryAllocationLogs'
import useStyles from './styles/ReservesModalRow.styles'

export type ReservesModalRowPropsType = {
  data: SystemReserve
  index: number
}

const ReservesModalRow: React.FC<ReservesModalRowPropsType> = ({
  data,
  index
}) => {
  const classes = useStyles()
  return (
    <div className={classes.tableRow}>
      <Typography variant="body1">{index + 1}</Typography>
      <Typography variant="body1">{getTranslate(data.status)}</Typography>
      <Tooltip title={data.failedReason || ''}>
        <Typography variant="body1">
          {(data.failedReason && data.failedReason.substring(0, 70) + '...') ||
            '-'}
        </Typography>
      </Tooltip>
      <Typography variant="body1">{data.reservationNumber || '-'}</Typography>
      <Typography
        variant="body1"
        className={data.canRetry ? classes.canRetry : classes.cantRetry}>
        {data.canRetry ? getTranslate('Yes') : getTranslate('No')}
      </Typography>
    </div>
  )
}
export default ReservesModalRow
